document.addEventListener('DOMContentLoaded', () => {  
  const navSlider = document.querySelector('.mobile-nav-wrapper');
  
  if (navSlider) {
      const splide = new Splide(navSlider, {
          arrows: true,
          arrowPath: 'M16.3153 16.6681C15.9247 17.0587 15.9247 17.6918 16.3153 18.0824C16.7058 18.4729 17.339 18.4729 17.7295 18.0824L22.3951 13.4168C23.1761 12.6357 23.1761 11.3694 22.3951 10.5883L17.7266 5.9199C17.3361 5.52938 16.703 5.52938 16.3124 5.91991C15.9219 6.31043 15.9219 6.9436 16.3124 7.33412L19.9785 11.0002L2 11.0002C1.44772 11.0002 1 11.4479 1 12.0002C1 12.5524 1.44772 13.0002 2 13.0002L19.9832 13.0002L16.3153 16.6681Z',
          autoWidth: true,
          pagination: false,
          gap: '36px',
          perMove: 1,
          mediaQuery: 'min',
          breakpoints: {
                  872: {
                  destroy: true,
                          },       
                       }
      });
  
      splide.mount();

      let activeSlideIndex = localStorage.getItem('activeSlideIndex');
      if (activeSlideIndex !== null) {
        splide.go(parseInt(activeSlideIndex));
      }

      splide.on('moved', function (newIndex) {
        localStorage.setItem('activeSlideIndex', newIndex);
      });
  }
});